import type { ChatRoom } from "@omnabase/shared";

/** Team chat's Tickets group, the pure rule (the ticket discussion round, 2026-11-02; brief rule 8, the red team's findings 11 and 13): which
 *  ticket discussions the column lists. The server sends at most `CHAT_TICKET_ROOMS.max` (those with a message in the last 30 days and every
 *  followed one with unread); the short list shows the `RECENT_TICKETS` newest open or pending plus every unread one and the open one; "Show all"
 *  (`?tickets=all`) shows what the server sent. The order: unread first, then the newest message. */
export const RECENT_TICKETS = 8;

const latestFirst = (a: ChatRoom, b: ChatRoom) => (b.lastEventAt ?? "").localeCompare(a.lastEventAt ?? "");

/** the ticket rooms the group lists, in its order */
export function ticketRoomsShown(rooms: ChatRoom[], opts: { all?: boolean; open?: string | null } = {}): ChatRoom[] {
  const tickets = rooms.filter((r) => r.kind === "ticket");
  const listed = opts.all ? tickets : folded(tickets, opts.open ?? null);
  return listed.sort((a, b) => (b.unread > 0 ? 1 : 0) - (a.unread > 0 ? 1 : 0) || latestFirst(a, b) || a.id.localeCompare(b.id));
}

/** the short list (before "Show all"): the newest open or pending discussions, every unread one and the open one (the queue-and-chat-column
 *  round, 2026-11-03: a read resolved or archived ticket's discussion waits behind "Show all") */
function folded(tickets: ChatRoom[], open: string | null): ChatRoom[] {
  const newest = tickets.filter((r) => !quietTicket(r)).sort(latestFirst).slice(0, RECENT_TICKETS);
  return [...new Set([...newest, ...tickets.filter((r) => r.unread > 0 || r.id === open)])];
}

/** a resolved or archived ticket's discussion reads quieter in the column (it stays writable: question 10) */
export const quietTicket = (r: Pick<ChatRoom, "ticketStatus">) => r.ticketStatus === "resolved" || r.ticketStatus === "archived";
